import React, { useRef, useState } from "react";
import { Form } from "antd";
import { InputText } from "../InputText";
import { InputType } from "../../../models";
import { getIconUrl } from "../../../services/asset";
import { getInputTextListErrors } from "../../../containers/AdFormPage/GroupPage/GroupControls/Control/FormItem/ValidationRuleResolver/InputTextListValidator";
import styles from "./styles.scss";

const defaultMaxItems = 5;

const toItems = (value, field) => {
  const items = value ? value[field] : undefined;

  if (Array.isArray(items)) {
    return items;
  }

  return items ? [items] : [];
};

const InputTextList = props => {
  const { field, title, isRequired, placeholder, isDisabled, maxItems, addLabel, value, onChange } = props;

  const nextKey = useRef(0);
  const createRow = (item = "") => ({ key: nextKey.current++, value: item });

  const [rows, setRows] = useState(() => {
    const items = toItems(value, field);
    return (items.length ? items : [""]).map(item => createRow(item));
  });
  const rowsRef = useRef(rows);

  const updateRows = nextRows => {
    rowsRef.current = nextRows;
    setRows(nextRows);
    onChange({ [field]: nextRows.map(row => row.value).filter(item => item) });
  };

  const handleRowChange = (key, rowValue) => {
    const text = rowValue && typeof rowValue === "object" ? rowValue[field] : rowValue;
    updateRows(rowsRef.current.map(row => (row.key === key ? { ...row, value: text || "" } : row)));
  };

  const addRow = () => updateRows([...rowsRef.current, createRow()]);

  const removeRow = key => updateRows(rowsRef.current.filter(row => row.key !== key));

  const fieldErrors = props["data-__field"] && props["data-__field"].errors;
  const rowErrors = fieldErrors ? getInputTextListErrors(props, rows.map(row => row.value)) : [];
  const canAdd = rows.length < (maxItems || defaultMaxItems);

  return (
    <div className={styles.list}>
      {title && (
        <div className={styles.title}>
          <span className={`control-title ${isRequired ? "required" : ""}`}>{title}</span>
        </div>
      )}
      {rows.map((row, index) => (
        <Form.Item
          key={row.key}
          className={styles.itemCell}
          validateStatus={rowErrors[index] ? "error" : ""}
          help={rowErrors[index]}
        >
          <div className={styles.row}>
            <InputText
              field={field}
              placeholder={placeholder}
              valueType={InputType.string}
              isDisabled={isDisabled}
              value={{ [field]: row.value }}
              onChange={rowValue => handleRowChange(row.key, rowValue)}
            />
            {rows.length > 1 && (
              <span className={styles.removeRow} onClick={() => removeRow(row.key)}>
                <img alt={"Ukloni"} src={getIconUrl("garbage.svg")} />
              </span>
            )}
          </div>
        </Form.Item>
      ))}
      {canAdd && (
        <div className={styles.addRow} onClick={addRow}>
          <img alt={addLabel} src={getIconUrl("circled-plus-red.svg")} />
          <span>{addLabel}</span>
        </div>
      )}
    </div>
  );
};

InputTextList.defaultProps = {
  addLabel: "Dodajte",
  onChange: () => null
};

export default InputTextList;



// WEBPACK FOOTER //
// ./src/components/FormControls/InputTextList/InputTextList.tsx